var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Chamsocxe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3399_5488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3399_5488",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19995 4H36.1999V36H4.19995V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3399_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5748 18.6189H13.4615C12.8827 18.6189 12.3876 19.035 12.288 19.6052L11.7771 22.5325H17.2592L16.7482 19.6052C16.6487 19.035 16.1537 18.6189 15.5748 18.6189Z",
    fill: "#01D27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1584 18.6189H24.2717C24.8505 18.6189 25.3456 19.035 25.4451 19.6052L25.9561 22.5325H20.474L20.985 19.6052C21.0844 19.035 21.5795 18.6189 22.1584 18.6189Z",
    fill: "#01D27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6874 25.5873C11.6874 24.7703 11.0251 24.108 10.2081 24.108C9.39119 24.108 8.72888 24.7703 8.72888 25.5873C8.72888 26.4042 9.39119 27.0665 10.2081 27.0665C11.0251 27.0665 11.6874 26.4042 11.6874 25.5873Z",
    fill: "#01D27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0458 25.5873C26.0458 24.7703 26.7081 24.108 27.525 24.108C28.342 24.108 29.0043 24.7703 29.0043 25.5873C29.0043 26.4042 28.342 27.0665 27.525 27.0665C26.7081 27.0665 26.0458 26.4042 26.0458 25.5873Z",
    fill: "#01D27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4743 26.6277H15.2589C14.6843 26.6277 14.2185 26.1619 14.2185 25.5873C14.2185 25.0126 14.6843 24.5468 15.2589 24.5468H22.4743C23.0489 24.5468 23.5147 25.0126 23.5147 25.5873C23.5147 26.1619 23.0489 26.6277 22.4743 26.6277Z",
    fill: "#01D27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 13.3162C29.0477 13.3162 28.7577 13.2055 28.5363 12.9842L27.2015 11.6494C26.9634 11.4112 26.9634 11.025 27.2015 10.7868L27.9422 10.0462C28.1804 9.80791 28.5666 9.80791 28.8049 10.0462L29.3379 10.5792L31.0326 8.88454C31.2708 8.64635 31.657 8.64635 31.8952 8.88454L32.6359 9.62523C32.874 9.86348 32.874 10.2497 32.6359 10.4878L30.1395 12.9842C29.9182 13.2055 29.628 13.3162 29.3379 13.3162Z",
    fill: "#01D27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4077 31.9075H5.50488V29.0822H32.2282V31.9075H22.2824",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3254 29.1446V31.4407C22.3254 31.9822 21.8865 32.4211 21.3449 32.4211H16.3882C15.8467 32.4211 15.4077 31.9822 15.4077 31.4407V29.1446",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41141 29.0822L5.70778 26.7946C5.16497 25.0298 5.78153 23.1138 7.25166 21.9968L8.19447 21.2805L11.9113 22.5793H18.8665",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3218 29.0822L32.0254 26.7946C32.5682 25.0298 31.9516 23.1138 30.4815 21.9968L29.5387 21.2805L25.8218 22.5793H18.8666",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19446 21.2805L9.97571 17.6412C10.7375 16.0847 12.3192 15.0978 14.0521 15.0978H18.8665",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8666 15.0978H23.681C25.414 15.0978 26.9956 16.0847 27.7575 17.6411L29.5387 21.2805",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5925 31.9701V34.3886C11.5925 34.9334 11.1509 35.375 10.6062 35.375H8.63066C8.08597 35.375 7.64429 34.9334 7.64429 34.3886V31.9701",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1406 31.9701V34.3886C26.1406 34.9334 26.5822 35.375 27.127 35.375H29.1025C29.6472 35.375 30.0889 34.9334 30.0889 34.3886V31.9701",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.438 21.2355L31.085 19.5788H32.8666",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2952 21.2355L6.6482 19.5788H4.82495",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6227 4.62502L35.5748 6.76677V9.2954C35.5748 13.0837 33.1917 16.4623 29.623 17.7334C26.0542 16.4623 23.671 13.0837 23.671 9.2954V6.76677L29.6232 4.62502",
    stroke: "#01D27B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3399_5488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4.19995 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Chamsocxe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2chamsocxe.8ff1fe99.svg";
export { ForwardRef as ReactComponent };